/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CaptchaInfo/view.blocks to change it.
import CaptchaText from './CaptchaText/index'
import CaptchaTextLink from './CaptchaTextLink/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CaptchaInfo({
  children,
  viewPath = "/DesignSystem/CaptchaInfo"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="CaptchaInfo.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<CaptchaText
  viewPath={`${viewPath}/CaptchaText`}
 text="This site is protected by reCAPTCHA and the Google"
/>
<div
  data-testid="CaptchaInfo.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<CaptchaTextLink
  viewPath={`${viewPath}/CaptchaTextLink`}
 goTo="https://policies.google.com/privacy"
 text="Privacy Policy"
/>
<CaptchaText
  viewPath={`${viewPath}/CaptchaText`}
 text="and"
/>
<CaptchaTextLink
  viewPath={`${viewPath}/CaptchaTextLink`}
 goTo="https://policies.google.com/terms"
 text="Terms of Service"
/>
<CaptchaText
  viewPath={`${viewPath}/CaptchaText`}
 text="apply."
/>
</div>
</div>
{children}
</React.Fragment>)
}